export default `
# Timberland ({domain}) robots.txt
User-agent: *

Disallow: /*?CountryPref*
Disallow: /*/c/*filter=*
Disallow: /*/c/*sort=*
Disallow: /*/c/*storeFilter=*
Disallow: /*/collections/*?*
Disallow: /*/search
Disallow: /*/size-chart$
Disallow: /*/size-chart?
Disallow: */cart$
Disallow: */checkout*
Disallow: */order/success
Disallow: */product/review

# AdsBot-Google
User-agent: AdsBot-Google
Disallow: */cart$
Disallow: */checkout/
Disallow: */order/success

#Googlebot-image
User-agent: Googlebot-image
Disallow:

# Amazon's user agent
User-agent: AmazonProductDiscoverybot
Disallow: /

#sitemap
Sitemap: {sitemapUrl}

# ThousandEyes Crawler
User-agent: Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/118.0.5993.70 Safari/537.36
Disallow: /
`
